import { NegotiationLineItem } from '@luminovo/http-client';
import { getScenarioVolume } from './getScenarioVolume';
import { monetaryValue } from './monetaryValueMath';

export function getScenarioTotalVolume(negotiationLineItems: Array<NegotiationLineItem>, scenarioId?: number) {
    const values = negotiationLineItems.map((li) => getScenarioVolume(li, scenarioId) ?? monetaryValue.zero);
    return monetaryValue.sum(values);
}
